import { type Component } from 'vue';

import AemuiClassInterestForm from './class-interest-form/ClassInterestForm.vue';
import AemuiDynamicLeadForm from './dynamic-lead-form/DynamicLeadForm.vue';
import AemuiDynamicMobileCta from './dynamic-mobile-cta/DynamicMobileCta.vue';
import AemuiEmbeddedLeadForm from './embedded-lead-form/EmbeddedLeadForm.vue';
import AemuiFindALocation from './find-a-location/FindALocation.vue';
import AemuiLaicChat from './laic-chat/LaicChat.vue';
import AemuiLazyloadComponent from './lazyload-component/LazyloadComponent.vue';
import AemuiLeadForm from './lead-form/leadForm.vue';
import AemuiMarketLevelMap from './market-level-map/MarketLevelMap.vue';
import AemuiPartnershipMarketingForm from './partnership-marketing-form/PartnershipMarketingForm.vue';
import AemuiScheduleATour from './schedule-a-tour/scheduleATour.vue';
import AemuiWellnessForm from './wellness-form/wellnessForm.vue';

export default {
	AemuiClassInterestForm,
	AemuiDynamicLeadForm,
	AemuiDynamicMobileCta,
	AemuiEmbeddedLeadForm,
	AemuiFindALocation,
	AemuiLaicChat,
	AemuiLazyloadComponent,
	AemuiLeadForm,
	AemuiMarketLevelMap,
	AemuiPartnershipMarketingForm,
	AemuiScheduleATour,
	AemuiWellnessForm
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
} as { [key: string]: Component<any, any, any, any, any> };
